module.exports = __webpack_public_path__ + "static/media/fj.e9e11609.svg";